module.exports = __webpack_public_path__ + "png/emoji.png?d8b02a156a5120db2bdf7f94f1bc89f5";